module.exports = __webpack_public_path__ + "static/media/ico-del.970aa541.svg";